import React, { Fragment, useEffect, useState } from "react";
import { Step, Stepper } from "react-form-stepper";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import StepWizard from "react-step-wizard";
import { translate } from "react-switch-lang";
import { toast } from "react-toastify";
import { SupportDto } from "../../../models/supportDto";
import { useHttpClient } from "../../../security/hooks/axiosProvider";
import StepOne from "./step-one/stepOne";
import StepTwo from "./step-two/stepTwo";

const AddSupport = (props: any) => {
  toast.configure();
  const location = useLocation<any>();
  const httpClient = useHttpClient(true);
  const path = "/Mediatheque/image/";
  const [, setIsFomrValid] = useState(false);
  const [isOnUpdate, setisOnUpdate] = useState(false);
  const [checked, setChecked] = useState<boolean>(false);
  const [, setTitleSupport] = useState("");
  const [pathSupport] = useState(location.pathname.split("/")[2] ? "/Mediatheque/Categories/" + location.pathname.split("/")[2] + "/" : "/Mediatheque/Categories/" + props.path + "/");
  const [selectedSupport, setSelectedSupport] = useState<any>(null);
  const [selectedSupportImage, setSelectedSupportImage] = useState<any>(null);
  const [selectedSupportEdit] = useState<any>(null);
  const [isShowDropZone, setIsShowDropZone] = useState(true);
  const [activeStep, setActiveStep] = useState(0);
  const [, setStepWizard] = useState(null);
  const [supportDto, setSupportDto] = useState(new SupportDto());
  const { setValue } = useForm({
    mode: "onChange",
    defaultValues: {
      dateSupport: props?.support?.dateSupport ? props.support.dateSupport : "2021",
      title: props.support?.title ? props.support.title : "",
      language: props.support?.language ? props.support.language : "",
      documentTypeId: props.support?.documentTypeId ? props.support.documentTypeId : 0,
      listThematic: props.support?.listThematic ? props.support.listThematic : [],
      listCountry: props.support?.listCountry ? props.support.listCountry : [],
    },
  });
  useEffect(() => {
    if (props.support) {
      setIsFomrValid(true);
      setisOnUpdate(true);
      setValue("dateSupport", props.support?.dateSupport);
      setTitleSupport(props.support?.pathSupport?.slice(props.support?.pathSupport?.lastIndexOf("/") + 1, props.support?.pathSupport?.length));
      if (props.support.urlImage) {
        setIsShowDropZone(false);
      }
      setChecked(props.support.download);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [httpClient]);

  const onSubmit = (data: SupportDto) => {
    props?.resetAllFieldSearch();
    if (!isOnUpdate) {
      let formData = new FormData();
      data.categoryId = props.categoryId;
      data.download = checked;
      if (selectedSupport) {
        if (selectedSupportImage) {
          formData.append("file", selectedSupportImage);
          httpClient.current
            ?.post(`/support/files?path=${path}`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then(response => {
              data.pathImage = response.data;
              formData = new FormData();
              formData.append("file", selectedSupport);
              httpClient.current
                ?.post(`/support/files?path=${pathSupport}`, formData, {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                })
                .then(response => {
                  data.pathSupport = response.data;
                  httpClient.current?.post("/support", data).then(response => {
                    toast.success(props.t("message_toastr_add_pdf"), {
                      position: toast.POSITION.TOP_RIGHT,
                      autoClose: 5000,
                    });
                    props.getListSupport();
                    props.closeToggle();
                  });
                });
            });
        } else {
          formData = new FormData();
          formData.append("file", selectedSupport);
          httpClient.current
            ?.post(`/support/files?path=${pathSupport}`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then(response => {
              data.pathSupport = response.data;
              httpClient.current?.post("/support", data).then(response => {
                toast.success(props.t("message_toastr_add_pdf"), {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 5000,
                });
                props.getListSupport();
                props.closeToggle();
              });
            });
        }
      }
    } else {
      hanldeUpdateSupport(data);
    }
  };

  const handleUpdatingImage = (support: SupportDto) => {
    let formData = new FormData();
    formData.append("file", selectedSupportImage);
    httpClient.current
      ?.post(`/support/files?path=${path}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(response => {
        support.pathImage = response.data;
        if (selectedSupportEdit) {
          let form = new FormData();
          form.append("file", selectedSupportEdit);
          httpClient.current
            ?.post(`/support/files?path=${pathSupport}`, form, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then(response => {
              support.pathSupport = response.data;
              httpClient.current?.put("/support", support).then(response => {
                props.getListSupport();
                toast.success(props.t("message_toastr_update"), {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 5000,
                });
                props.getListSupport();
                props.closeToggle();
              });
            });
        } else {
          httpClient.current?.put("/support", support).then(response => {
            props.getListSupport();
            toast.success(props.t("message_toastr_update"), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
            props.getListSupport();
            props.closeToggle();
          });
        }
      });
  };

  const hanldeUpdateSupport = (support: SupportDto) => {
    support.supportId = props.support.supportId;
    support.pathSupport = props.support.pathSupport;
    support.pathImage = props.support.pathImage;
    support.urlImage = props.support.urlImage;
    if (isShowDropZone) {
      support.urlImage = "";
      support.pathImage = "";
    }
    support.urlSupport = props.support.urlSupport;

    support.download = checked;
    support.categoryId = props.support.categoryId;
    support.supportESId = props.support.supportESId;
    let formData = new FormData();
    if (selectedSupportImage) {
      handleUpdatingImage(support);
    } else if (selectedSupportEdit) {
      formData = new FormData();
      formData.append("file", selectedSupportEdit);
      httpClient.current
        ?.post(`/support/files?path=${pathSupport}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(response => {
          support.pathSupport = response.data;
          httpClient.current?.put("/support", support).then(response => {
            toast.success(props.t("message_toastr_update"), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
            props.getListSupport();
            props.closeToggle();
          });
        });
    } else {
      httpClient.current?.put("/support", support).then(response => {
        props.closeToggle();
        toast.success(props.t("message_toastr_update"), {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 5000,
        });
        props.getListSupport();
      });
    }
  };

  const assignStepWizard = instance => {
    setStepWizard(instance);
  };
  const handleStepChange = e => {
    setActiveStep(e.activeStep - 1);
  };
  const assignSupport = val => {
    setSupportDto(user => ({
      ...user,
      ...val,
    }));
  };
  let custom = {
    enterRight: "transition: 1s linear;",
    enterLeft: "transition:left 1s linear;",
    exitRight: "transition:left 1s linear;",
    exitLeft: "transition:left 1s linear;",
  };

  const lastStep = () => {
    onSubmit(supportDto);
  };
  return (
    <Fragment>
      <Stepper className={"p-0"} activeStep={activeStep}>
        <Step label={props.t("step_info")} />
        <Step label={props.t("step_attachements")} />
      </Stepper>
      <StepWizard transitions={custom} instance={assignStepWizard} onStepChange={handleStepChange}>
        <StepOne close={props.closeToggle} support={props.support} userCallback={assignSupport} />
        <StepTwo
          setChecked={setChecked}
          setSelectedSupportImage={setSelectedSupportImage}
          setSelectedSupport={setSelectedSupport}
          close={props.closeToggle}
          element={supportDto}
          last={lastStep}
          support={props.support}
          setIsShowDropZone={setIsShowDropZone}
          userCallback={assignSupport}
        />
      </StepWizard>
    </Fragment>
  );
};

export default translate(AddSupport);
